// extracted by mini-css-extract-plugin
export default {"wrapper":"vq0PkPYIyI5sSORUf2i1"};